import firebase from "firebase/app"
import "firebase/auth"
import "firebase/firestore"

// Firebase web config
//  TODO Move this to enviroment variables
const config = {
  apiKey: "AIzaSyA-bRLdQ2KLSA7vANz8AtMMWT-AxQY6NyU",
  authDomain: "brook-test-bb48b.firebaseapp.com",
  databaseURL: "https://brook-test-bb48b.firebaseio.com",
  projectId: "brook-test-bb48b",
  storageBucket: "brook-test-bb48b.appspot.com",
  messagingSenderId: "485825466442",
  appId: "1:485825466442:web:798d838565012210e016b3",
}

let instance = null

export default function getFirebase() {
  if (typeof window !== "undefined") {
    if (instance) return instance
    instance = firebase.initializeApp(config)
    return instance
  }

  return null
}
